import React from "react";
import Select from "react-select";
import "./FilterMenu.css";

const FilterMenu = ({ filters, setFilters, onClose, statuses, users }) => {
  const statusOptions = statuses.map((status) => ({
    value: status,
    label: status,
  }));
  const userOptions = users.map((user) => ({
    value: user.id,
    label: `${user.first_name} ${user.last_name}`,
  }));
  const vipOptions = [
    { value: "all", label: "All" },
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  return (
    <div className="mass-reassign-menu filter-menu">
      <h3>Filter Leads</h3>
      <div className="filter-control">
        <label>Status:</label>
        <Select
          isMulti
          options={statusOptions}
          value={statusOptions.filter((option) =>
            filters.statuses.includes(option.value)
          )}
          onChange={(selected) =>
            setFilters({
              ...filters,
              statuses: selected ? selected.map((s) => s.value) : [],
            })
          }
          placeholder="Select statuses..."
        />
      </div>
      <div className="filter-control">
        <label>Assigned To:</label>
        <Select
          isMulti
          options={userOptions}
          value={userOptions.filter((option) =>
            filters.assignedTo.includes(option.value)
          )}
          onChange={(selected) =>
            setFilters({
              ...filters,
              assignedTo: selected ? selected.map((s) => s.value) : [],
            })
          }
          placeholder="Select users..."
        />
      </div>
      <div className="filter-control">
        <label>VIP:</label>
        <Select
          options={vipOptions}
          value={vipOptions.find((option) => option.value === filters.vip)}
          onChange={(selected) =>
            setFilters({
              ...filters,
              vip: selected ? selected.value : "all",
            })
          }
          placeholder="Select VIP status..."
        />
      </div>
      <div className="filter-control">
        <label>Do Not Show Status:</label>
        <Select
          isMulti
          options={statusOptions}
          value={statusOptions.filter((option) =>
            filters.hiddenStatuses.includes(option.value)
          )}
          onChange={(selected) =>
            setFilters({
              ...filters,
              hiddenStatuses: selected ? selected.map((s) => s.value) : [],
            })
          }
          placeholder="Select statuses to hide..."
        />
      </div>
      <div className="actions">
        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

export default FilterMenu;
